import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs } from '../../enhancedMock';

export const FAQSection = () => (
  <section data-testid="faq-section" className="fade-in-section py-12 md:py-20 px-4 bg-gradient-to-b from-warmBeige/80 to-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto max-w-4xl">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Frequently Asked Questions</h2>
        <p className="text-sm md:text-xl text-gray-600">Find answers to common questions</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <Accordion type="single" collapsible className="space-y-3 md:space-y-4">
        {faqs.map((faq) => (
          <AccordionItem key={faq.id} value={`item-${faq.id}`} className="bg-white rounded-lg shadow-md border-none px-4 md:px-6">
            <AccordionTrigger className="text-left text-sm md:text-lg font-semibold text-darkBrown hover:text-primaryOrange py-4 md:py-6">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-gray-600 text-sm md:text-base pb-4 md:pb-6">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
